(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.controller('HelpViewController', ['$uibModalInstance', 'helpCategory', 'helpList', HelpViewControllerFn]);

    /* controlle for help modal */
    function HelpViewControllerFn($uibModalInstance, helpCategory, helpList) {
        var vm = this;

        vm.searchValue = "";
        vm.items = [];

        activate();

        // close modal
        vm.abort = function () {
            $uibModalInstance.dismiss("abort");
        };

        /* activation work */
        function activate() {
            // set created help
            vm.category = helpCategory;
            vm.helpList = helpList;
        }
    }
})();
